import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';

const commonColumns = [
    {
        Header: () => 'Solución financiera',
        id: 'id_solution',
        typeId: 'HeaderRequest',
        Cell: ({ row }) => {
            //:id_financial_solution/:id_persona/:id_solicitud
            return (
                <RequestIdTableCell
                    row={row}
                    url={`process/${row.original.id}/${row.original.persona.pk}/${row.original.solicitud_id}`}
                    idRoute={row.original.id}
                />
            );
        },
    },
    {
        Header: 'Fecha creación',
        accessor: 'created_at',
    },
    {
        Header: 'Tipo',
        accessor: 'tipo_solucion_financiera.label',
    },
    {
        Header: 'Nro crédito',
        accessor: 'num_credito',
    },
    {
        Header: 'Identificación',
        accessor: 'persona.numero_identificacion',
    },
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    {
        Header: 'Oficina',
        accessor: 'oficina.label',
    },
    {
        Header: 'Ejecutivo',
        accessor: 'ejecutivo.name',
    },
    {
        Header: 'Estado',
        accessor: 'estado.label',
    },
];

const requestsFinancialSolutionsStatus = [
    {
        id: 'soluciones_financieras',
        label: 'SOLUCIONES FINANCIERAS',
        responsable: null,
        status: '1,3,4,5,6,7',
        offices: true,
        columns: commonColumns,
        registrationLimit: 5,
    },
];
export default requestsFinancialSolutionsStatus;
